import {
    CheckCircleIcon,
    WarningIcon,
    WarningOctagonIcon,
} from '@phosphor-icons/react';
import { Toaster as SonnerToaster } from 'sonner';
import { Spinner } from '../Spinner';

const snackbarBase =
    'flex flex-row items-center gap-2.5 max-w-[356px] px-3 py-4 rounded-[8px] border border-grey-500 bg-grey-700/70 backdrop-blur-[20px] text-white-100';
const snackbarText = 'text-xs-medium text-white-100';
// ghostIdle Button variant. `!important` is required to beat Sonner's
// default `[data-button]` styles, which have higher CSS specificity.
const snackbarActionButton =
    '!bg-transparent !text-white-100 hover:!bg-grey-650 disabled:!text-grey-400';

export function Snackbar() {
    return (
        <SonnerToaster
            position="bottom-right"
            theme="dark"
            offset={32}
            icons={{
                loading: <Spinner size={16} className="shrink-0" />,
                success: (
                    <CheckCircleIcon
                        className="text-white-100 shrink-0"
                        size={16}
                    />
                ),
                error: (
                    <WarningOctagonIcon
                        className="text-danger-300 shrink-0"
                        size={16}
                    />
                ),
                warning: (
                    <WarningIcon
                        className="text-warning-100 shrink-0"
                        size={16}
                    />
                ),
            }}
            toastOptions={{
                classNames: {
                    toast: snackbarBase,
                    title: snackbarText,
                    description: snackbarText,
                    actionButton: snackbarActionButton,
                    cancelButton: 'bg-grey-500 text-white-100',
                    error: snackbarBase,
                    success: snackbarBase,
                    warning: snackbarBase,
                    loader: 'flex items-center justify-center size-4.5',
                },
            }}
            gap={10}
        />
    );
}
